import React from 'react';
import { Dropdown, DropdownFooter as SparkDropdownFooter } from '@spark';
import { TaskType } from '@/shared/domain/taskTypes';
import { formatOriginLabelsColumnLabel } from '@/features/datasets/components/DataSelection/ExtraParamsUtils';
/**
 * Compatibility footer for Ant Design table filter dropdowns in ColumnsAndData.
 * Maps the legacy onReset/onOk API onto Spark DropdownFooter.
 */
export const DropdownFooter = ({ onReset, onOk, hasSelectedItems }) => (
    <SparkDropdownFooter
        onClear={onReset}
        onApply={onOk}
        clearDisabled={!hasSelectedItems}
        applyLabel="OK"
    />
);

export const EditColumnsDropdown = ({
    availableExtraParamsKeys = [],
    tempSelectedColumns = [],
    onDetectedColumnChange,
    onOptuneColumnChange,
    onReset,
    onOk,
    taskType = null,
}) => {
    const detectedChildren = availableExtraParamsKeys.map((key) => ({
        label: formatOriginLabelsColumnLabel(key),
        type: 'checkbox',
        checked: tempSelectedColumns.includes(key),
        onClick: () => onDetectedColumnChange?.(key, !tempSelectedColumns.includes(key)),
    }));

    const specificAiChildren = [
        ...(taskType === TaskType.classification
            ? [{ key: 'optune_score', label: 'SpecificAI score' }]
            : []),
        { key: 'data_creation_type', label: 'Data Creation' },
        { key: 'dataset', label: 'Sample Origin' },
    ].map(({ key, label }) => ({
        label,
        type: 'checkbox',
        checked: tempSelectedColumns.includes(key),
        onClick: () => onOptuneColumnChange?.(key, !tempSelectedColumns.includes(key)),
    }));

    const items = [
        ...(detectedChildren.length > 0
            ? [{ label: 'Detected columns', children: detectedChildren }]
            : []),
        { label: 'SpecificAI columns', children: specificAiChildren },
    ];

    return (
        <Dropdown
            type="cascading"
            defaultExpanded
            showFooter
            items={items}
            onClear={onReset}
            onApply={onOk}
            clearDisabled={tempSelectedColumns.length === 0}
            applyLabel="OK"
            className="edit-columns-spark-dropdown"
        />
    );
};
